import { Bell, QrCode, Smartphone } from 'lucide-react';

import { useTranslation } from '@splitfiesta/i18n';
import { Card } from '@splitfiesta/ui';

import { StoreBadge } from '@/components/common/StoreBadge';

import { useNativeAppNudge } from '@/hooks/useNativeAppNudge';

const ADVANTAGES = [
  { key: 'nativeApp.card.push', Icon: Bell },
  { key: 'nativeApp.card.scan', Icon: QrCode },
  { key: 'nativeApp.card.native', Icon: Smartphone },
] as const;

/** One dismissable card on the groups list for phone-browser users. */
export function NativeAppCard() {
  const { t } = useTranslation('common');
  const { store, dismiss } = useNativeAppNudge();

  if (!store) return null;

  return (
    <Card data-testid="native-app-card">
      <h2 className="text-base font-semibold text-gray-900 dark:text-gray-100">
        {t('nativeApp.card.title')}
      </h2>
      <ul className="mt-3 space-y-2">
        {ADVANTAGES.map(({ key, Icon }) => (
          <li
            key={key}
            className="flex items-center gap-2 text-sm text-gray-600 dark:text-gray-300"
          >
            <Icon className="h-4 w-4 shrink-0 text-primary-500" />
            <span>{t(key)}</span>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex items-center justify-between gap-3">
        <StoreBadge store={store} size="sm" onClick={dismiss} />
        <button
          type="button"
          onClick={dismiss}
          className="text-sm font-medium text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          {t('nativeApp.banner.dismiss')}
        </button>
      </div>
    </Card>
  );
}
